import React, { useEffect } from "react";
import { useState } from "react";
import Navabar from "../components/Navbar";
import Cont from "../components/Cont";
import Footer from "../components/Footer";
// AKfycbwliWUq97pZBYQtqWbLzTHMxVNa5qshFFVdmKNbV4TU32XMXCa1qIdaUZmq6pLNXcbN
// https://script.google.com/macros/s/AKfycbxq94c3Dq4GNFxMh6hX79lgvlIdqqSshur3nx8amhL0zWVQRA5iEbIdFqaIl1rNSs7I/exec
function Contact(){
    const[firstName,setFirstName] = useState('');
    const[lastName,setLastName] = useState('');
    const[email,setEmail] = useState('');
    const[contact,setContact] = useState('');
    const[message,setMessage] = useState('');

    const handleFname = (e) => {
        setFirstName(e.target.value);
    }
    const handleLname = (e) => {
        setLastName(e.target.value);
    }
    const handleEmail = (e) => {
        setEmail(e.target.value);
    }
    const handleContact = (e) => {
        setContact(e.target.value);
    }
    const handleMessage = (e) => {
        setMessage(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // let data = {
        //     Name: firstName + " " + lastName,
        //     Email: email,
        //     Contact: contact,
        //     Message: message
        // };
        const formEle = document.querySelector("form");
        const formDatab = new FormData(formEle);
        // axios.post('https://sheet.best/api/sheets/4d58860a-46d1-42bf-be92-baab06307c6a', data)
        // .then(response => {
        // console.log(response);
        // })
        // console.log(data);
        fetch("https://script.google.com/macros/s/AKfycbzkOxI9KDgKoXz9n_qh4iRpMs8x5_pdLgZo_2Npeb_Qh10A8PLBB2scsO6nPS4DHaI/exec",
        {
            method:"POST",
            body:formDatab
        })
        .then((res) => res.json())
        .then((data) => {
            console.log(data);
        })
        .catch((error) => {
            console.log(error);
        });
        console.log(Object.fromEntries(formDatab));
        setFirstName('');
        setLastName('');
        setEmail('');
        setContact('');
        setMessage('');
    }

    return (
        <div>
            <Navabar/>
            <Cont/>
            <div className="flex lg:flex-row lg:p-32 lg:gap-x-20 lg:gap-y-0 flex-col md:p-16 p-6 gap-y-10">
                <div className="flex flex-col lg:w-1/2 gap-y-5">
                    <h2 className="flex text-4xl justify-center lg:justify-start m-4 lg:m-0">Get In Touch</h2>
                    <form className="flex gap-y-5 flex-col" action="/contact" onSubmit={(e) => handleSubmit(e)} >
                        <div className="flex flex-col md:flex-row gap-y-5 md:gap-x-5">
                            <input placeholder="First Name" type="text" name="FName" onChange={handleFname} id="" className="flex md:w-1/2 bg-slate-200 text-slate-950 h-10 rounded-xl p-4"/>
                            <input placeholder="Last Name" type="text" name="LName" onChange={handleLname} id="" className="flex md:w-1/2 bg-slate-200 text-slate-950 h-10 rounded-xl p-4"/>
                        </div>
                        <div className="flex flex-col md:flex-row gap-y-5 md:gap-x-5">
                            <input placeholder="Standard" type="text" name="Standard" onChange={handleEmail} id="" className="flex md:w-1/2 bg-slate-200 text-slate-950 h-10 rounded-xl p-4"/>
                            <input placeholder="Contact" type="text" name="Contact" onChange={handleContact} id="" className="flex md:w-1/2 bg-slate-200 text-slate-950 h-10 rounded-xl p-4"/>
                        </div>
                        <div className="flex">
                            <textarea placeholder="Message" name="Message" onChange={handleMessage} className="p-4 rounded-xl w-full h-32 bg-slate-200"/>
                        </div>
                        <div className="flex justify-center lg:justify-start">
                            <button type="submit"  className="flex text-2xl bg-[#005fb9] p-3 text-slate-50 rounded-2xl hover:bg-[#141619] transition-all duration-300 ease-in-out">Submit</button>
                        </div>
                    </form>
                </div>
                <div className="flex lg:w-1/2 h-96">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15009.217833454484!2d75.3300562!3d19.8693619!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdb999e727c31d9%3A0x9ac74a1dd0dd4610!2sDhoot%20Physics%20Academy!5e0!3m2!1sen!2sin!4v1686495779839!5m2!1sen!2sin" title="Google Map Location" className="flex w-full"/>                
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Contact;